'use client';

import React from 'react';
import { useForm } from 'react-hook-form';
import { ibow2_proto_PortalOfficeListing } from '@/init/swagger';
import {
  SearchStationNameType,
  SearchStationNameResolver,
} from '@/schemas/SearchStationNameSchema';
import { swaggerClientForNonMember } from '@/init/swaggerClient';
import { apiRequest } from '@/helpers/apiRequestHelper';
import { useSnackbar } from '@/hooks/useSnackbar';

export const useLogic = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [displayListings, setDisplayListings] = React.useState<
    ibow2_proto_PortalOfficeListing[]
  >([]);
  const [errorMessage, setErrorMessage] = React.useState('');

  const { openSnackbar } = useSnackbar();

  const method = useForm<SearchStationNameType>({
    resolver: SearchStationNameResolver,
    defaultValues: {
      portal_office_name: '',
    },
  });

  const search = (): void => {
    setIsLoading(true);
    setErrorMessage('');

    apiRequest({
      requestFunc: () =>
        swaggerClientForNonMember.portalOfficeListing.postPortalOfficeListingsSearchForNonMember(
          {
            body: {
              portal_office_name: method.getValues('portal_office_name') || '',
            },
          },
        ),
      resolveFunc: (res) => {
        // 検索結果が30件以上の場合、backendで30件だけ返され、エラーメッセージが添付される仕様
        if (res.code === 101 && !!res.message) {
          setErrorMessage(res.message);
        }
        setDisplayListings(res.portal_office_listings_for_non_member || []);
        setIsLoading(false);
      },
      rejectFunc: () => {
        openSnackbar('ステーションの検索に失敗しました', 'error');
        setIsLoading(false);
      },
    });
  };

  const handleSearch = () => {
    search();
  };

  return {
    method,
    handleSearch,
    displayListings,
    errorMessage,
    isLoading,
  };
};
